import { LsFormCheckboxComponent } from '../../../shared/form/ls-checkbox/ls-form-checkbox.component';
import { LsFormMultiSelectComponent } from '../../../shared/components/select/multi/ls-multi-select/ls-form-multi-select.component';
import { LsFormRowColumnsSelectComponent } from '../../../shared/form/ls-row-column-select/ls-form-row-column-select.component';
import { LsInputTextComponent } from '../../../shared/form/ls-input-text/ls-input-text.component';
import { RowColumnValue } from './row.column.value.type';
import { Setting } from './setting';
import { Value } from './value.type';
import { ValuePair } from '../../../shared/interfaces/ValuePair';
import { LsFormMultiCheckboxComponent } from 'app/shared/form/ls-multi-checkbox/ls-form-multi-checkbox.component';
import { Observable } from 'rxjs';

export class SettingsField {
  public component;
  public defaultValue: Value;
  public description = '';
  public disabled?: boolean;
  public key: string;
  public options?: Array<any>;
  public visible = true;
  public required = false;
  public title: string;
  public type: string;
  public value: Value;
  public defaultAsync?: Value;
  public max?: number | RowColumnValue;

  public componentClass: string;
  public placeholder: string;
  public minSelected: number;
  public maxSelected: number;
  public items: Array<ValuePair> | Observable<Array<ValuePair>>;
  public multiSelectSearch = false;
  public info?: string;

  constructor(setting?: Setting) {
    this.defaultValue = setting.defaultValue;
    this.defaultAsync = setting.defaultAsync;
    this.description = setting.description;
    this.disabled = setting.disabled;
    this.key = setting.key;
    this.options = setting.options;
    this.visible = setting.visible === undefined ? true : setting.visible;
    this.required = setting.required;
    this.title = setting.title;
    this.type = setting.type;
    this.max = setting.max;
    this.componentClass = setting.componentClass;
    this.placeholder = setting.placeholder;
    this.minSelected = setting.minSelected;
    this.maxSelected = setting.maxSelected;
    this.items = setting.items;
    this.multiSelectSearch = setting.multiSelectSearch;
    this.info = setting.info;

    this.setComponentForType();
  }

  private setComponentForType(): void {
    if (this.type === 'boolean') {
      this.component = LsFormCheckboxComponent;
      this.value = false;
    } else if (this.type === 'text') {
      this.component = LsInputTextComponent;
      this.value = '';
    } else if (this.type === 'rowColumnSelect') {
      this.component = LsFormRowColumnsSelectComponent;
    } else if (this.type === 'multi') {
      this.component = LsFormMultiSelectComponent;
    } else if (this.type === 'multi-checkbox') {
      this.component = LsFormMultiCheckboxComponent;
    }
  }
}
